import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createGcpRouterIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M29.8 22.8V27L22.8 20L29.8 13V17.2H34V22.8H29.8ZM10.2 17.2H6V22.8H10.2V27L17.2 20L10.2 13V17.2ZM22.8 27V22.8H17.2V27H13L20 34L27 27H22.8ZM22.8 13V17.2H17.2V13H13L20 6L27 13H22.8Z" fill="#4285F4"/>
    <path d="M29.8003 17.1998V13L22.8003 20L29.8003 27V22.8003H34V17.1998H29.8003ZM17.1998 22.8003V27H13L20 34L27 27H22.8003V22.8003H17.1998ZM24.073 25.7273H26.7278L24.073 23.0725V25.7273ZM13.2722 25.7273H15.927V23.0725L13.2722 25.7273ZM18.9995 20L17.472 21.5276H22.5281L21.0006 20L22.5281 18.4725H17.472L18.9995 20ZM13 13H17.1998V17.1998H22.8003V13H27L20 6.00003L13 13ZM15.927 16.9276V14.2728H13.2722L15.927 16.9276ZM24.073 16.9276L26.7278 14.2728H24.073V16.9276ZM6.00002 22.8003H10.1998V27L17.1998 20L10.1998 13V17.1998H6.00002V22.8003ZM35.2728 24.073H31.073V30.0725L28.3995 27.399L27.8999 27.8999L20 35.7997L11.5993 27.399L11.0996 27.8999L8.92705 30.0725V24.073H4.72729V15.9271H8.92705V9.92759L11.5993 12.5998L12.1002 12.1002L20 4.20032L28.3995 12.5998L28.9004 12.1002L31.073 9.92759V15.9271H35.2728V24.073Z" fill="white"/>

  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpRouterIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpRouterIcon,
);
